// extracted by mini-css-extract-plugin
export var addressFields = "_m6-0";
export var animationContainer = "_m6-1";
export var footer = "_m6-2";
export var lineItems = "_m6-3";
export var modalContent = "_m6-4";
export var orderName = "_m6-5";
export var strong = "_m6-6";
export var warning = "_m6-7";